import { observer } from 'mobx-react';
import * as React from 'react';
import SegmentStore from '../../../SegmentStore';
import SurveyCompleted from './SurveyCompleted';

interface Props {
  segmentStore: SegmentStore;
}

const StreamlinedSurveySegment: React.FC<Props> = ({ segmentStore }) => (
  <SurveyCompleted segmentStore={segmentStore} />
);

export default observer(StreamlinedSurveySegment);
